<template>
  <div class="merchant-info-List" v-loading="loadingPage">
    <div class="header">
      <div class="title">商户信息</div>
      <div class="search">
        <el-form inline class="inline-form" :model="searchForm" label-width="85px" label-position="left">
          <el-form-item label="门店搜索">
            <el-input v-model="searchForm.merchantName" placeholder="请输入店铺简称" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商户编号" style="margin-left: 30px">
            <el-input v-model="searchForm.merchantId" size="small" placeholder="请输入商户编号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="门店编号">
            <el-input v-model="searchForm.transToolCustomerName" placeholder="请输入门店编号"></el-input>
          </el-form-item> -->
          <el-button type="primary" @click="search" class="btnBase searchBtn">查询</el-button>
        </el-form>
      </div>
    </div>
    <div class="table-list">
      <div class="tabledata-con">
        <el-table :data="tableData" style="width: 100%" border v-loading="loadingTable">
          <el-table-column prop="merchantName" label="门店名称" align="center"></el-table-column>
          <el-table-column prop="merchantId" label="商户编号" align="center"> </el-table-column>
          <el-table-column prop="shopId" label="门店编号" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span class="table-btn" @click="viewDetial(scope.row)">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            prev-text="上一页"
            next-text="下一页"
            :page-size="page.pageSize"
            layout="prev, pager,total,next"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          >
          </el-pagination>
        </el-col>
      </div>
    </div>
  </div>
</template>
<script>
// import { queryShopList, queryMerchantInfo, queryMerchantRate } from "@/api/merchant-info";
import { queryShopList } from "@/api/merchant-info";

export default {
  data() {
    return {
      searchForm: {
        merchantName: "",
        merchantId: "",
      },
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      tableData: [],
      loadingTable: false,
      loadingPage: false,
    };
  },
  methods: {
    viewDetial(row) {
      this.$router.push({
        path: "/merchant-info/modifyInfo",
        query: { merchantId: row.merchantId, shopType: row.shopType },
      });
    },
    search() {
      this.page.pageNo = 1;
      this.queryShopList("search");
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryShopList();
    },
    // 获取门店列表
    queryShopList(type) {
      const params = Object.assign(this.searchForm, this.page);
      this.loadingPage = true;
      return queryShopList(params).then((res) => {
        this.loadingPage = false;
        if (res.data.error_code === 0) {
          if (res.data.data.list.length === 1 && type !== "search") {
            this.viewDetial(res.data.data.list[0]);
          } else {
            this.tableData = res.data.data.list;
          }
        }
      });
    },
  },
  created() {
    this.queryShopList();
  },
};
</script>
<style lang="scss">
.merchant-info-List {
  .btnBase{
    height: 32px;
    margin-top: 5px;
    line-height: 0px;
  }
  background-color: #f7f7f7;
  > .header {
    .search{
      margin-top: 40px;
      margin-bottom: 20px;
    }
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
  }
  .table-list {
    background: #f7f7f7;
    overflow: hidden;
    .tabledata-con {
      border-top: 20px solid #eee;
      padding: 40px 50px;
      background: #fff;
      overflow: hidden;
      .table-btn {
        margin-right: 10px;
        cursor: pointer;
        color: #ff9c00;
      }
    }
  }
}
</style>
